import React, { ChangeEvent, forwardRef, InputHTMLAttributes } from 'react';

import styles from './styles.module.css';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  setChecked: (checked: boolean) => void;
  variant: 'primary' | 'secondary';
  style?: React.CSSProperties;
  sameColorAsTheCrossedOutLabel?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      id,
      checked = false,
      setChecked,
      variant = 'primary',
      onChange,
      ...props
    },
    ref
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      setChecked(e.target.checked);
      onChange?.(e);
    };

    return (
      <label
        htmlFor={id}
        style={props.style}
        className={`${styles.checkbox} ${styles[variant]} ${
          checked && props.sameColorAsTheCrossedOutLabel
            ? styles.sameColorAsTheCrossedOutLabel
            : ''
        }`}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          ref={ref}
          {...props}
        />
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
